<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            Atribuir Perfil em Lote
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-select
                  v-model="content.perfil"
                  label="Perfil"
                  :items="form.lists.perfis"
                  :item-text="'nome'"
                  :item-value="'id'"
                  :rules="[(v) => $required(v)]"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-list>
                  <v-subheader>Nome dos Usuários</v-subheader>
                  <v-list-item
                    v-for="(profissional, i) in content.profissionais"
                    :key="i"
                    :value="profissional"
                    color="primary"
                    variant="plain"
                  >
                    <v-list-item-title><v-icon>mdi mdi-account</v-icon> {{ profissional.nomeSocial || profissional.nome }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="'Salvar'"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Organograma } from "~/commons/classes/organograma";
import ManterPerfilService from "~/services/manter-perfil.service";

export default {
  props: new DialogProps(Organograma),
  mixins: [ManterPerfilService],
  data: () => ({
    form: {
      lists: {
        perfis: [],
      },
    },
  }),
  methods: {
    buscarPerfis() {
      this.$buscarPerfis({params: {situacao: true}}).then(({ data }) => (this.form.lists.perfis = data.lista));
    },
    salvar() {
      if (this.$validarFormulario()) {
        this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const body = { usuarios: this.content.profissionais.map((p) => p.id), perfil: this.content.perfil };
          this.$atribuirPerfilEmLote(body, this.content.perfil).then(() => {
            this.$emit("onSave");
            this.$emit("onClose");
            this.$notifySuccess("Operação realizada com sucesso.");
          });
        });
      }
    },
  },
  mounted() {
    this.buscarPerfis();
  },
};
</script>
  